webpackJsonp([113292631941163],{

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(105);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventListing = __webpack_require__(42);
	
	var _eventListing2 = _interopRequireDefault(_eventListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'breadcrumb' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Home'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u203A '
	      ),
	      'Programm'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      'Alle Termine am ',
	      (0, _moment2.default)(pathContext.date).format('D.MM.YYYY')
	    ),
	    _react2.default.createElement(_eventListing2.default, { events: data.allEventsYaml.edges.map(function (edge) {
	        return edge.node;
	      }) })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-date-js-0bcaa8b05329cdc52dad.js